export default __webpack_public_path__ + "static/media/unlocked.10b78756.png";